import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { login } from "../../actions/authAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";

const Login = () => {
  const appLoading = useSelector((state) => state.alert.appLoading);

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().required("Required"),
    password: Yup.string().required("Required"),
  });

  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = (values) => {
    const params = {
      username: values.email,
      password: values.password,
    };
    dispatch(
      login({
        params,
      })
    );
  };

  return (
    <div className="login-container">
      <h2 className="login-title">User Login</h2>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <Form>
              <input
                type="text"
                style={{ display: "none" }}
                autoComplete="username"
              />
              <input
                type="password"
                style={{ display: "none" }}
                autoComplete="current-password"
              />
              <FormikControl
                control="input"
                type="text"
                label="login"
                placeholder="Username Or Email"
                name="email"
                autoComplete="username"
                hasError={formik.errors.email && formik.touched.email}
              />
              <FormikControl
                control="input"
                type={showPassword ? "text" : "password"}
                label="Password"
                showPassword={showPassword}
                setShowPassword={setShowPassword}
                placeholder="Credentials"
                name="password"
                autoComplete="current-password"
                hasError={formik.errors.password && formik.touched.password}
              />

              <div className="submit-section">
                <button
                  className="btn-orange"
                  type="submit"
                  disabled={!formik.isValid || appLoading}
                >
                  Sign In
                </button>
                <Link to="/forget" className="link-orange">
                  Forgot your password?
                </Link>
              </div>
            </Form>
          );
        }}
      </Formik>
      <p className="text mt-5">
        New User? Please{" "}
        <span>
          <Link className="link-orange" to="/register">
            Register here.
          </Link>
        </span>
      </p>
      <p className="text mt-8">
        Having trouble signing into your account? <br />
        Please contact{" "}
        <span>
          <a
            className="link-orange"
            href="https://devapp.myherbalpharmacy.com/contact/"
          >
            Technical Support.
          </a>
        </span>
      </p>
    </div>
  );
};

export default Login;
